import { APIStatus } from '@application/common/enums/api-status';
import { createSlice } from '@reduxjs/toolkit';
import { createEmployeeHourTypeAsync, getAllEmployeeHourTypeAsync, getEmployeeHourTypeByIdAsync, updateEmployeeHourTypeAsync } from './employeehourtypeThunk';
const initialState = {
    status: APIStatus.IDLE
};
export const employeeHourStateSlice = createSlice({
    name: 'employeeHourTypes',
    initialState,
    reducers: {
        clearUpdateEmployeeHourType: (state) => {
            state.updateEmployeeHourType = null;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(getAllEmployeeHourTypeAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(getAllEmployeeHourTypeAsync.fulfilled, (state, action) => {
            state.status = APIStatus.IDLE;
            state.employeeHourTypes = action.payload;
            state.employeeActiveHourTypesDropDown = action.payload.filter(hourType => hourType.isActive === true).map((hourType) => {
                return {
                    label: `${hourType.name}`,
                    value: hourType.id,
                    number: hourType.internalSurcharge
                };
            });
            state.employeeAllHourTypesDropDown = action.payload.map((hourType) => {
                return {
                    label: `${hourType.name}`,
                    value: hourType.id,
                    number: hourType.internalSurcharge
                };
            });
        })
            .addCase(getAllEmployeeHourTypeAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        builder
            .addCase(createEmployeeHourTypeAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(createEmployeeHourTypeAsync.fulfilled, (state, action) => {
            state.status = APIStatus.IDLE;
            state.employeeHourType = action.payload;
        })
            .addCase(createEmployeeHourTypeAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        builder
            .addCase(updateEmployeeHourTypeAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(updateEmployeeHourTypeAsync.fulfilled, (state, action) => {
            state.status = APIStatus.IDLE;
            state.employeeHourType = action.payload;
        })
            .addCase(updateEmployeeHourTypeAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        builder
            .addCase(getEmployeeHourTypeByIdAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(getEmployeeHourTypeByIdAsync.fulfilled, (state, action) => {
            state.status = APIStatus.IDLE;
            state.updateEmployeeHourType = action.payload;
        })
            .addCase(getEmployeeHourTypeByIdAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
    }
});
export default employeeHourStateSlice.reducer;
export const { clearUpdateEmployeeHourType } = employeeHourStateSlice.actions;
